import React, { useState } from 'react';
import SentMailTableConfig from './SentMailTableConfig';
import LightButton from '../../components/button/LightButton';
import { Actions } from '../../../client/Actions';
import { useLoaderContext } from '../../components/loader/LoaderContext';
import { Button, Modal } from 'react-bootstrap';
import ConfirmButton from '../../components/button/ConfirmButton';
import DivStart from '../../components/div/DivStart';
import SendMailDropdown from './SendMailDropdown';
import ShortSentMailTableConfig from './ShortSentMailTableConfig';
import ExtendedFunctionalTableComponent from '../../components/table/ExtendedFunctionalTableComponent';

const SentMailsComponent = ({ reservationId }) => {
  const [formKey, setFormKey] = useState(Date.now());
  const { showLoader, hideLoader } = useLoaderContext();
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');

  return (
    <>
      <ExtendedFunctionalTableComponent
        shadow={false}
        key={formKey}
        title={'Wiadomości email'}
        withoutCreate={true}
        trick="Przy ponownym wysłaniu wiadomości system uwzględni aktualne dane rezerwacji oraz bieżący adres e-mail klienta."
        toolBarButton={
          <div className={'d-flex gap-2'}>
            <SendMailDropdown
              reservationId={reservationId}
              onSent={() => setFormKey(Date.now())}
            />
          </div>
        }
        columns={SentMailTableConfig}
        shortVersionColumns={ShortSentMailTableConfig}
        header={true}
        api={`/send-mail/reservation/${reservationId}`}
        removable={false}
        editable={false}
        width={12}
        additionalButtons={(row) => (
          <DivStart>
            <ConfirmButton
              confirmTitle={'Ponowna wysyłka'}
              confirmDescription={'Czy napewno chcesz wysłać ponownie email?'}
              variant="primary"
              onConfirm={() => {
                showLoader();
                Actions.post(`/send-mail/${row.id}/resend`, null, () => {
                  hideLoader();
                  setFormKey(Date.now());
                });
              }}
              size="sm"
            >
              Ponów
            </ConfirmButton>
            <LightButton
              onClick={() => {
                setModalBody(row.body);
                setShowModal(true);
              }}
              size="sm"
            >
              Pokaż
            </LightButton>
          </DivStart>
        )}
      />

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Treść wiadomości</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: modalBody }} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Zamknij
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SentMailsComponent;
